import { FC } from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faX, faCheck, faMinus } from '@fortawesome/free-solid-svg-icons';
import { Validity } from '../../services/Password';

const Requirement = styled.li(({ theme }) => {
  const { color, type } = theme;

  return `
    color: ${color.grayscale[0]};
    font-size: ${type.size.small};
    position: relative;
    padding: 0.25rem 0 0.25rem ${type.size.large};

    &.invalid {
      color: ${color.primary.regular};
    }

    &.valid {
      color: ${color.tertiary.regular};
    }

    svg {
      height: ${type.size.regular};
      display: inline-block;
      position: absolute;
      left: 0;
      top: 0.5rem;
      height: 0.75rem;
    }

    ul {
      margin-left: 1rem;
    }
  `;
});

export interface IRequirement {
  valid: Validity;
}

const RequirementItem: FC<IRequirement> = ({ children, valid }) => {
  let style = '';

  switch (valid) {
    case Validity.VALID:
      style = 'valid';
      break;
    case Validity.INVALID:
      style = 'invalid';
      break;
    default:
      style = '';
  }

  return (
    <Requirement className={style}>
      {valid === Validity.VALID && <FontAwesomeIcon icon={faCheck} />}
      {valid === Validity.INVALID && <FontAwesomeIcon icon={faX} />}
      {valid === Validity.UNCHECKED && <FontAwesomeIcon icon={faMinus} />}
      {children}
    </Requirement>
  );
};

export default RequirementItem;
